import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import { StaffsService } from '@/modules/staffs/services';
import CertificatesListState from './state';
import CertificatesListMutations from './mutations';
import CertificatesListGetters from './getters';

const staffService = new StaffsService();

export default class CertificatesListActions extends Actions<
CertificatesListState,
CertificatesListGetters,
CertificatesListMutations,
  // eslint-disable-next-line no-use-before-define
CertificatesListActions
> {
  async get_certs() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_CERTS(true);
      const { data, meta } = await staffService.get_certs(payload);

      this.mutations.SET_CERTS(data.items);
      this.mutations.SET_USERS(data.users);
      this.mutations.SET_COURSES(data.courses);
      this.mutations.SET_CERT_VALIDITY(data.cert_validity);
      this.mutations.SET_COURSES_REQUESTS_NOT_AVAILABLE(data.is_request_courses_not_available);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_CERTS(false);
    }
  }
}
